import { OnlineReputationDataSettingsModel } from '../../../shared/models';

export const defaultOnlineReputationSettings: OnlineReputationDataSettingsModel =
  {
    customPrompt: null,
  };
